// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".package-order-form[data-v-1983599a] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  -webkit-column-gap: 16px;\n     -moz-column-gap: 16px;\n          column-gap: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
